<div class="row mt-3">
  <div class="col mb-2">
    <h5>Approvals</h5>
    <span class="ml-3"
      >Approvers to ensure consultation with all relevant SME's as
      appropriate</span
    >
  </div>
</div>
<form-workflow
  [form]="form"
  [sectionNumber]="2"
  [amendmentSectionNumbers]="[12]"
  [leftConfigs]="[101, 103, 105, 113, 115, 117]"
  [rightConfigs]="[102, 104, 105, 114, 116, 118]"
  [service]="service"
>
</form-workflow>
